export const SET_PROPOSAL_SEEN = 'SET_PROPOSAL_SEEN';

export interface SetProposalSeen {
  type: typeof SET_PROPOSAL_SEEN;
  proposalSeen: any;
}

export type LoadActions = SetProposalSeen